/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useContext } from 'react';
import { UeContainer, UeElement, UeReference } from '@oneaudi/falcon-tools';
import { NavigationItemProps } from '../../../interfaces';
import { TrackingServiceContext, useInPageNavContext } from '../../context';
import { StyledLink, StyledListItem } from './NavigationStyles';
import { useTracking } from '../../hooks/use-tracking';

export const OverViewItem = ({
  hasSubMenu,
  path,
  title,
  index,
  handleSelectedItem,
  hasParentElement,
  subLevelChildLabel,
  isLastElement,
  isSecondaryLevel,
  isMobile,
}: NavigationItemProps) => {
  const { sameLevelActiveLink, impressionTracking } = useInPageNavContext();
  const { trackingService } = useContext(TrackingServiceContext);
  const tracking = useTracking(trackingService);
  let notActiveClass: boolean = false;
  const isActive = index === sameLevelActiveLink?.index;

  return (
    <StyledListItem
      role="none"
      className="sibling-item sub-level-parent"
      $hasParentElement={hasParentElement}
      $isSecondaryLevel={isSecondaryLevel}
      $isMobile={isMobile}
    >
      <UeContainer propertyPath="sameLevelInpageNavigation" label="Navigation item">
        <UeReference propertyPath="overviewLink" label="Overview Link field">
          <StyledLink
            aria-label={title}
            className={`sibling-link ${isSecondaryLevel ? `secondary-level-link${isActive ? ' active-link' : ''}` : ''}`}
            href={path}
            role="menuitem"
            onClick={(e) => {
              e.stopPropagation();
              e?.preventDefault(); // @ts-ignore
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              const element: HTMLElement | null = e?.target?.parentElement;
              const classActive = element?.classList;
              const hasSubMenuClass = classActive?.contains('has-sub-menu');
              notActiveClass = !classActive?.contains('active-link');

              if (handleSelectedItem && hasSubMenuClass) {
                handleSelectedItem({
                  id: `${title?.replace(/ /g, '-')}-link`,
                  index,
                  text: title,
                  subLevelChildLabel,
                  href: path,
                });
              }

              tracking?.navigationItemClick({
                elementName: 'text link',
                label: title,
                clickID: '',
                targetURL: path || '',
                value: impressionTracking?.value || '',
                pos: index.toString(),
                isSubNavigation: false,
                eventName: `inpage navigation - click on link`,
              });

              if (!hasSubMenu && path && notActiveClass && typeof window !== 'undefined') {
                window.location.href = path;
              }
            }}
            rel="noopener"
            target="_self"
            title={title}
            data-index={index}
            $hasParentElement={hasParentElement}
            $isSecondaryLevel={isSecondaryLevel}
            $isLastElement={isLastElement}
          >
            <UeElement type="text" property="Text" label="Navigation item">
              {title}
            </UeElement>
          </StyledLink>
        </UeReference>
      </UeContainer>
    </StyledListItem>
  );
};
